import React, { useEffect, useState } from "react";

function LoadingTablePage({ title, loading }) {
  const [isFadingIn, setIsFadingIn] = useState(false);

  useEffect(() => {
    // Delay the fade-in effect by 1 second
    const fadeInTimeout = setTimeout(() => {
      setIsFadingIn(true);
    }, 250);

    const elements = document.querySelectorAll(".bg-mute-100");

    if (loading) {
      // Add pulsing animation when loading is true
      elements.forEach((element) => {
        element.classList.add("animate-pulse");
      });
    } else {
      // Remove pulsing animation when loading is false
      elements.forEach((element) => {
        element.classList.remove("animate-pulse");
      });
    }

    // Clear timeout when the component unmounts or loading changes
    return () => {
      clearTimeout(fadeInTimeout);
    };
  }, [loading]);

  return (
    <div
      className={`px-4 py-8 flex flex-col gap-4 w-full mb-[400px] transition-opacity duration-500 ${
        isFadingIn && loading ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="flex flex-col gap-4 pr-[11rem]">
        <div className="rounded-md shadow-md w-full h-10 bg-mute-100"></div>
        <div className="rounded-md shadow-md w-full h-40 bg-mute-100"></div>
      </div>
    </div>
  );
}

export default LoadingTablePage;
